import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { savePrepay, searchPrepayDetailsId } from '@app/actions/myoffice/prepay/prepay.action';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { payCard, setCardResult } from '@app/actions/shoppingmall/kicc-payment.action';
import { loadCodesS, loadCodesY } from '@app/actions/system/code.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { CheckoutConstant } from '@app/common/constant/checkout.constant';
import { LenConstant } from '@app/common/constant/len.constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { DateFilterModel } from '@app/models/components/date-filter.model';
import { SelectDropdownModel } from '@app/models/components/select-dropdown.model';
import { PrepaySearchModel } from '@app/models/myoffice/prepay/prepay-search.model';
import { KICCCardModel } from '@app/models/shoppingmall/kicc-card.model';
import { PdtDetailModel } from '@app/models/shoppingmall/pdt-detail.model';
import { CodeModel } from '@app/models/system/code.model';
import { ResultProc } from '@app/models/system/result-proc.model';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { getPrepayHeader, getResultPrepay, PrepayState } from '@app/selectors/myoffice/prepay/prepay.selector';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { KICCPaymentState, getKICCCardResult } from '@app/selectors/shoppingmall/kicc-payment.selector';
import { CodeState, getCodesS, getCodesY } from '@app/selectors/system/code.selector';
import { SmWownetState, getSmWownetPg } from '@app/selectors/system/sm-wownet.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

declare const addEventListenerForPaymentMethod: any;

@Component({
  selector: 'register-prepay-popup',
  templateUrl: './prepay-popup.component.html',
  styleUrls: ['./prepay-popup.component.css']
})
export class PrepayPopupComponent implements OnInit {

  today = new Date();

  @Input()
  showRegisPrepay: boolean = false;

  @Input() pdtInfo: PdtDetailModel = {} as PdtDetailModel;

  @Output()
  clickClosePopup = new EventEmitter<boolean>();

  form: FormGroup = {} as FormGroup;

  params: any = {};

  formPrepayPopup = this.fb.group({
    cardAmt: ["", [Validators.required]],
    card: this.fb.group({
      personal: this.fb.group({
        cardNo1: ["", [Validators.required]],
        cardNo2: ["", [Validators.required]],
        cardNo3: ["", [Validators.required]],
        cardNo4: ["", [Validators.required]],
        cardHolder: ["", [Validators.required]],
        cardMM: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        cardYY: ["", [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
        cardPassword: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        cardInstall: ["00"],
        birthday: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      }),
      general: this.fb.group({
        cardNo1: ["", [Validators.required]],
        cardNo2: ["", [Validators.required]],
        cardNo3: ["", [Validators.required]],
        cardNo4: ["", [Validators.required]],
        cardHolder: ["", [Validators.required]],
        cardMM: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        cardYY: ["", [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
        cardPassword: ["", [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        cardInstall: ["00"],
        birthday: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      }),
    })
  });

  smWownetPg$ = new Observable<SmWownetPgModel>();
  smWownetPg: SmWownetPgModel = {} as SmWownetPgModel;

  cardResult$ = new Observable<KICCCardModel>();
  cardResult: KICCCardModel = {} as KICCCardModel;

  result$= new Observable<ResultProc>;
  result= {} as ResultProc;

  codesY$ = new Observable<CodeModel[]>;

  yearOptions: SelectDropdownModel[] = [];
  dateFilterSelected: DateFilterModel = new DateFilterModel();

  options: SelectDropdownModel[] = [];
  selectedValue: SelectDropdownModel = new SelectDropdownModel();

  generalCardInstallOptions: SelectDropdownModel[] = CheckoutConstant.cardInstallOptions;
  generalCardSelected: SelectDropdownModel = this.generalCardInstallOptions[0];
  personalCardInstallOptions: SelectDropdownModel[] = CheckoutConstant.cardInstallOptions;
  personalCardSelected: SelectDropdownModel = this.personalCardInstallOptions[0];

  typeOptions: SelectDropdownModel[] = [];
  typeSelected: SelectDropdownModel = new SelectDropdownModel();
  codesS$ = new Observable<CodeModel[]>;

  prepayInfo$ = new Observable<PrepaySearchModel[]>;
  prepayInfo: PrepaySearchModel[] = [];
  totalPrepay: number = 0;

  constructor(
    private fb: FormBuilder,
    private _smWownetStore: Store<SmWownetState>,
    private _codeStore: Store<CodeState>,
    private _kiccPaymentStore: Store<KICCPaymentState>,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _wAlertStore: Store<WAlertState>,
    private _prepayStore: Store<PrepayState>
  ) { 
    this.smWownetPg$ = this._smWownetStore.select(getSmWownetPg);
    this.codesY$ = this._codeStore.select(getCodesY);
    this.cardResult$ = this._kiccPaymentStore.select(getKICCCardResult);
    this.result$ = this._prepayStore.select(getResultPrepay);
    this.codesS$ = this._codeStore.select(getCodesS);
    this.prepayInfo$ = this._prepayStore.select(getPrepayHeader);
  }

  ngOnInit(): void {
    this.smWownetPg$.subscribe(res => {
      this.smWownetPg = res;
      if (ValidationUtil.isNotNullAndNotEmpty(res.comId)) {
        if (typeof addEventListenerForPaymentMethod === "function") {
          setTimeout(() => addEventListenerForPaymentMethod(), 500);
        }
      }
    });
    
    setTimeout(() => {
      this.prepayInfo$.subscribe(res => {
        if(ValidationUtil.isNotNullAndNotEmpty(res)){
          let tmp = 0;
          for(let i=0; i<res.length; i++){
            tmp = tmp + +res[i].amtbalance;
          }
          this.totalPrepay = tmp;
        }
      });
    }, 500);

    this._codeStore.dispatch(loadCodesY());
    this._codeStore.dispatch(loadCodesS())
    this.codesY$.subscribe(res => {
      this.yearOptions = [];
      res.forEach((item) => this.yearOptions.push({ label: item.codeName, value: ConvertUtil.convertToSring(item.codeS1) }));
    });

    this.codesS$.subscribe(res => {
      this.typeOptions = [];
      this.typeOptions.push({label:"전체" , value:""})
      res.forEach((item) => this.typeOptions.push({ label: item.codeCd +' ' +item.codeName, value: ConvertUtil.convertToSring(item.codeCd) }));
      this.typeSelected = this.typeOptions[0];
    });
  }

  handleOnKeyUpNumber(_e: any): void {
    let value = _e.value;
    if (value) {
      value = value.replace(/[^0-9-+]/g, "");
    } else {
      value = "";
    }
    _e.value = value;
  }

  handleOnClickClosePopup(): void {
    this.clickClosePopup.emit(false);
  }

  convertData(): any {
    const form = this.formPrepayPopup.value;
    const loginedInfo = AuthUtil.getLoginedInfo();

    let cardCd = "";
    let cardNo = "";
    let cardInstall = "00";
    let cardHolder = "";
    let cardYYMM = "";
    let cardPassword = "";
    let birthday = "";

    let customerType = "";
    let reqType = "0";
    let certType = "0";
    let freeInstallmentTypeCode = "00";
    let userType = "";

    let _selector = document.querySelector(".w-card-prepay.selected");
    if (_selector) {
      let _type = _selector.getAttribute("data-index");
      if (_type === "1") {
        //personal card
        customerType = "2";
        userType = "0";
        let card = form.card?.personal;
        if (card) {
          cardNo += ConvertUtil.convertToSring(card.cardNo1);
          cardNo += ConvertUtil.convertToSring(card.cardNo2);
          cardNo += ConvertUtil.convertToSring(card.cardNo3);
          cardNo += ConvertUtil.convertToSring(card.cardNo4);
          cardInstall = ConvertUtil.convertToSring(card.cardInstall);
          cardHolder = ConvertUtil.convertToSring(card.cardHolder);
          cardYYMM = ConvertUtil.convertToSring(card.cardYY) + ConvertUtil.convertToSring(card.cardMM);
          cardPassword = ConvertUtil.convertToSring(card.cardPassword);
          birthday = ConvertUtil.convertToSring(card.birthday);
        }
      } else if (_type === "2") {
        //general card
        customerType = "1";
        userType = "1";
        let card = form.card?.general;
        if (card) {
          cardNo += ConvertUtil.convertToSring(card.cardNo1);
          cardNo += ConvertUtil.convertToSring(card.cardNo2);
          cardNo += ConvertUtil.convertToSring(card.cardNo3);
          cardNo += ConvertUtil.convertToSring(card.cardNo4);
          cardInstall = ConvertUtil.convertToSring(card.cardInstall);
          cardHolder = ConvertUtil.convertToSring(card.cardHolder);
          cardYYMM = ConvertUtil.convertToSring(card.cardYY) + ConvertUtil.convertToSring(card.cardMM);
          cardPassword = ConvertUtil.convertToSring(card.cardPassword);
          birthday = ConvertUtil.convertToSring(card.birthday);
        }
      }
    }

    const data = {
      comCd: environment.comCd,
      comId: environment.comId,
      ordNoTmp: "1234",
      userid: ConvertUtil.convertToSring(loginedInfo?.userid),

      customerType: customerType,
      reqType: reqType,
      certType: certType,
      freeInstallmentTypeCode: freeInstallmentTypeCode,
      userType: userType,

      amt: this.formPrepayPopup.get('cardAmt')?.value,
      cardAmt: this.formPrepayPopup.get('cardAmt')?.value,
      amtUsed: 0,
      remark: "",
      cardCd: cardCd,
      cardRate: "",
      cardInstall: cardInstall,
      cardInstall1: cardInstall,
      cardNo: cardNo,
      cardHolder: cardHolder,
      cardYYMM: cardYYMM,
      expiryDate: cardYYMM,
      cardExpYear:cardYYMM.substring(0,4),
      cardExpMonth:cardYYMM.substring(4,6),
      cardAppNo: "",
      cardPw: cardPassword,
      cardAuth: birthday,
      birthday: birthday,
      

      cntCd: ConvertUtil.convertToSring(loginedInfo?.cntCd),
      ctrCd: ConvertUtil.convertToSring(loginedInfo?.ctrCd),
      userKindCd: ConvertUtil.convertToSring(loginedInfo?.userKindCd),
      username:ConvertUtil.convertToSring(loginedInfo?.userName),
      workUser: ConvertUtil.convertToSring(loginedInfo?.userid),
      pdtCd: this.pdtInfo.pdtCd,
      pdtName: this.pdtInfo.pdtName,
    };

    this.params = data;
   
  }

  getMessageValidation(): string {
    let temp1: any;
    let temp2: any;
    let temp3: any;
    let temp4: any;

    let msg = "";

    temp1 = this.formPrepayPopup?.get("cardAmt")?.errors;
    if (temp1 && temp1.required) {
      msg += '결제금액을 입력해주십시오.';
      msg += "<br>";
    }

    let card: any = this.formPrepayPopup.get("card");
    if (card) {
      let _selector = document.querySelector(".w-card-prepay.selected");
      if (_selector) {
        let _type = _selector.getAttribute("data-index");
        if (_type === "1") {
          //personal card
          card = card.get("personal");
        } else if (_type === "2") {
          //general card
          card = card.get("general");
        }
      }
      if (card) {
        temp1 = card?.get("cardNo1")?.errors;
        temp2 = card?.get("cardNo2")?.errors;
        temp3 = card?.get("cardNo3")?.errors;
        temp4 = card?.get("cardNo4")?.errors;
        if ((temp1 && temp1.required) || (temp2 && temp2.required) || (temp3 && temp3.required) || (temp4 && temp4.required)) {
          msg += MessageConstant.msgCardNoRequired;
          msg += "<br>";
        }
    
        temp1 = card?.get("cardHolder")?.errors;
        if (temp1 && temp1.required) {
          msg += MessageConstant.msgCardHolderRequired;
          msg += "<br>";
        }
    
        temp1 = card?.get("cardMM")?.errors;
        temp2 = card?.get("cardYY")?.errors;
        if ((temp1 && temp1.required) || (temp2 && temp2.required)) {
          msg += MessageConstant.msgCardYYMMRequired;
          msg += "<br>";
        } else if ((temp1 && temp1.minlength) || (temp2 && temp2.minlength) || (temp1 && temp1.maxlength) || (temp2 && temp2.maxlength)) {
          msg += MessageConstant.msgCardYYYYMMInvalid;
          msg += "<br>";
        }
    
        temp1 = card?.get("birthday")?.errors;
        let _selector = document.querySelector(".w-card-prepay.selected");
        if (_selector) {
          let _type = _selector.getAttribute("data-index");
          if (_type === "1") {
            //personal card
            if ((temp1 && temp1.required)) {
              msg += MessageConstant.msgCardBirthdayRequired;
              msg += "<br>";
            } else if ((temp1 && temp1.minlength) || (temp1 && temp1.maxlength)) {
              msg += MessageConstant.msgCardBirthdayInvalid;
              msg += "<br>";
            }
          } else if (_type === "2") {
            //general card
            if ((temp1 && temp1.required)) {
              msg += MessageConstant.msgCardBusinessNoRequired;
              msg += "<br>";
            }
          }
        }
        
        temp1 = card?.get("cardPassword")?.errors;
        if ((temp1 && temp1.required)) {
          msg += MessageConstant.msgCardPasswordRequired;
          msg += "<br>";
        } else if ((temp1 && temp1.minlength) || (temp1 && temp1.maxlength)) {
          msg += MessageConstant.msgCardPasswordInvalid;
          msg += "<br>";
        }
      }
    }

    return msg;
  }

  handleOnSubmit(): void {
    this.convertData();

    let msg = this.getMessageValidation();
    if (ValidationUtil.isNotNullAndNotEmpty(msg)) {
      this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.cancelled, message: msg } }));
      return;
    }

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._kiccPaymentStore.dispatch(payCard({ params: this.params }));

    this.cardResult$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res.resCd)) {
        if (res.resCd === "0000") {
          this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
          const params = { ...this.params, moneyNo: res.moneyNo, pgcno: res.pgCno, cardAppNo: res.authNo, cardAppDate: res.authDate.substring(0, 8), cardCd: res.cardCd};
          this.params = this.getParamSave(params);
          this.savePrepay(this.params);
        } else {
          this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.cancelled, message: res.resMsg } }));
          setTimeout(() => {
            this._kiccPaymentStore.dispatch(setCardResult({ cardResult: {} as KICCCardModel }));
          }, 2000);
        }
      }
    });
  }

  getParamSave(params: any): any {
    let data = {
      comId:environment.comId,
      moneyno: params.moneyNo,
      userid: params.userid,
      date: this.today.getFullYear() + ConvertUtil.convertToZeroDecimal(this.today.getMonth() + 1) + ConvertUtil.convertToZeroDecimal(this.today.getDate()),
      candate: "",
      kind: environment.comCd + 's02',
      amt: params.amt,
      amtused: params.amtUsed,
      cardCd: params.cardCd,
      cardno: params.cardNo,
      cardholder: params.cardHolder,
      cardinstall: params.cardInstall,
      cardyymm: params.cardYYMM.substring(2,6),
      yy: params.cardYYMM.substring(0,2),
      mm: params.cardYYMM.substring(2,4),
      cardappno: params.cardAppNo,
      date2: params.cardAppDate,
      selfyn: "",
      useYn: "Y",
      remark: params.remark,
      pgcno:params.pgcno
    }
   return data;
  }

  savePrepay(params: any): void {
    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._prepayStore.dispatch(savePrepay({ params: params }));

    this.result$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res.retCode)) {
        this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
        if (res.retCode === "OK") {            
          let msg = `${res.retStr}`;
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: msg} }));
          this.resetResultAction();    
        } else {
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.cancelled, message: res.retStr } }));
          setTimeout(() => {
            this._kiccPaymentStore.dispatch(setCardResult({ cardResult: {} as KICCCardModel }));
          }, 3000);
        }
      }
    });
  }

  resetResultAction(): void {
    this.formPrepayPopup.reset();

    this.formPrepayPopup.patchValue({ card: { personal: {cardInstall: ConvertUtil.convertToSring("00")} } });
    this.formPrepayPopup.patchValue({ card: { general: {cardInstall: ConvertUtil.convertToSring("00")} } });
    this._kiccPaymentStore.dispatch(setCardResult({ cardResult: {} as KICCCardModel }));
    this._prepayStore.dispatch(searchPrepayDetailsId({ userid: ConvertUtil.convertToSring(AuthUtil.getLoginedInfo()?.userid) }));
  }
}
